let config = {
    apiKey: "AIzaSyBpcz28gzI9MG5ColKexTs_G7tSjV41Gfo",
    authDomain: "av-digital-cpg.firebaseapp.com",
    databaseURL: "https://av-digital-cpg.firebaseio.com",
    projectId: "av-digital-cpg",
    storageBucket: "av-digital-cpg.appspot.com",
    messagingSenderId: "435827866195"
  };

  export default config;


// WEBPACK FOOTER //
// ./src/app/config.ts